import _merge from 'lodash.merge'
import _range from 'lodash.range'

export const merge = _merge
export const range = _range
